import { useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import { EstadosActivacionInstallOTEnumChoice, ROUTER_PATHS } from "@/shared";
import { useGetOrdenTrabajo } from "@/shared/actions/erp";
import { useCheckPermissions, useLoaders, useRecordLock } from "@/shared/hooks";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { SaveActivacionInstallPendingOT } from "../../shared/components";

export type ActivacionInstallPendingPageProps = {};

const ActivacionInstallPendingPage: React.FC<
  ActivacionInstallPendingPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_ordentrabajo);
  const returnUrlActivacionInstallOTPage =
    ROUTER_PATHS.operaciones.activacionesInstalacionNav;
  const navigate = useNavigate();

  const setAlert = useUiStore((s) => s.setAlert);

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetOrdenTrabajo(id!);
  useLoaders(isLoading || isRefetching);

  useEffect(() => {
    if (!data?.data?.id_orden_trabajo) return;
    if (
      data?.data?.estado_activacion !==
      EstadosActivacionInstallOTEnumChoice.EN_ESPERA
    ) {
      setAlert(
        true,
        "La orden de trabajo no tiene el estado correcto",
        AlertSeverityEnum.error
      );
      navigate(returnUrlActivacionInstallOTPage);
    }
  }, [data?.data?.id_orden_trabajo]);
  useRecordLock(data?.data?.contrato_data?.id_contrato!);
  
  // se comenta el isRefetching x el invalidateQuery en form
  if (isLoading /* || isRefetching */) return null;
  if (!data?.data?.id_orden_trabajo)
    return <Navigate to={returnUrlActivacionInstallOTPage} />;

  return (
    <SaveActivacionInstallPendingOT
      titlePage="Activación de Instalación Pendiente"
      ordenTrabajo={data.data}
    />
  );
};

export default ActivacionInstallPendingPage;
